import {
  GUEST_ENGAGEMENT_TRUSTPILOT_MICRO_COMBO,
  OPTIMIZELY_VARIANT_KEYS,
} from '../../../constants'
import { useSpecificOptimizelyUserDecision } from '../optimizely-for-client'

const VARIANTS_MAP: Record<string, 'standard' | 'microCombo'> = {
  [OPTIMIZELY_VARIANT_KEYS.TRUSTPILOT_MICRO_COMBO_VARIANT]: 'microCombo',
}

export function useTrustpilotMicroCombo(): 'standard' | 'microCombo' {
  const decisionObj = useSpecificOptimizelyUserDecision(
    GUEST_ENGAGEMENT_TRUSTPILOT_MICRO_COMBO,
    true,
  )

  return VARIANTS_MAP?.[decisionObj?.variationKey] ?? 'standard'
}
